class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartItems = this.querySelector('cart-drawer-items') || this.querySelector('cart-items');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setLastVisitedCollection();
    this.setCountinueShoppingButtonLink();
    
    // Observe when drawer becomes active to ensure currency conversion runs
    this.setupCurrencyConversionObserver();
  }
  
  setupCurrencyConversionObserver() {
    // Create a MutationObserver to watch for when drawer becomes active
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('active') && target === this) {
            // Drawer just became active - ensure currency conversion runs
            setTimeout(() => {
              // Hide any loading spinners
              this.querySelectorAll('.loading__spinner').forEach(spinner => {
                spinner.classList.add('hidden');
              });
              
              // Reinitialize currency conversion
              if (typeof initialCurrencyChange === 'function') {
                initialCurrencyChange();
              }
              
              // Update footer count if function exists
              if (typeof updateFooterCount === 'function') {
                updateFooterCount();
              }
            }, 200);
          }
        }
      });
    });
    
    // Observe this element for class changes
    observer.observe(this, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also listen for cart drawer update events
    document.addEventListener('cart-drawer-updated', () => {
      // If drawer is currently open, reinitialize currency conversion
      if (this.classList.contains('active')) {
        setTimeout(() => {
          // Hide any loading spinners
          this.querySelectorAll('.loading__spinner').forEach(spinner => {
            spinner.classList.add('hidden');
          });
          
          // Reinitialize currency conversion
          if (typeof initialCurrencyChange === 'function') {
            initialCurrencyChange();
          }
          
          // Update footer count if function exists
          if (typeof updateFooterCount === 'function') {
            updateFooterCount();
          }
        }, 100);
      }
    });
  }

  setLastVisitedCollection() {
    if (window.location.pathname.includes('/collections/')) {
      sessionStorage.setItem('lastVisitedCollection', window.location.pathname);
    }
  }

  setCountinueShoppingButtonLink() {
    const continueShoppingButton = this.querySelector('#CartDrawer-ContinueShopping');
    // if (continueShoppingButton) {
    //   continueShoppingButton.href = sessionStorage.getItem('lastVisitedCollection') || '/';
    // }
  }

  ensureCheckoutButtonEnabled() {
    // Ensure checkout button is enabled when cart drawer opens (unless cart is empty)
    const checkoutButton = this.querySelector('#CartDrawer-Checkout');
    if (checkoutButton && !this.classList.contains('is-empty')) {
      checkoutButton.disabled = false;
    }
  }
  /*
    ┌─────────────────────────────────────────────────────────────────────────────┐
    │   Header Cart Icon Bubble                                                   │
    └─────────────────────────────────────────────────────────────────────────────┘
  */
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    /* 
    // Get the delivery type options element
    const deliveryTypeOptions = document.querySelector('.cart_delivery_type_options');
    const deliveryTypeLabel = document.querySelector('.cart_delivery_type_label');

    // Check conditions before calling getLatestShippingMethods
    if (deliveryTypeOptions && deliveryTypeOptions.innerHTML === '' && window.latestCartData && window.latestCartData.attributes && Object.keys(window.latestCartData.attributes).length > 0 && window.latestCartData.attributes.shipping_date !== 'null' && window.latestCartData.attributes.cutoffTime !== 'null' && window.latestCartData.attributes.variantId !== 'null' && window.latestCartData.attributes.english_city !== 'null') {
      // Extract needed values from cart attributes
      const { english_city: city, shipping_date: yyyyMmDdDate, cutoffTime: cut_off, variantId: variant_id, shipping_method } = window.latestCartData.attributes;

      // Convert date from YYYY-MM-DD to DD-MM-YYYY
      const dateArray = yyyyMmDdDate.split('-');
      const date = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`; // Format: "DD-MM-YYYY"

                                                                                
      // Call the function with the extracted values
      // Now in DD-MM-YYYY format
      const shippingTime = window.latestCartData?.attributes?.shipping_time || '';
      const isShippingMethodNull = shipping_method === null || shipping_method === 'null';

      this.cartItems.getLatestShippingMethods({
        city,
        date,
        cut_off,
        variant_id,
        labelToSet: isShippingMethodNull
          ? deliveryTypeLabel?.dataset?.defaultText
          : (shippingTime
              ? `${shipping_method} on ${this.formatTimeToAMPM(shippingTime)}`
              : shipping_method)
      });
    }
    */

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      
      // Trigger currency conversion after drawer animation completes
      // This ensures all DOM updates are complete before converting prices
      setTimeout(() => {
        // Hide any loading spinners
        this.querySelectorAll('.loading__spinner').forEach(spinner => {
          spinner.classList.add('hidden');
        });
        
        // Reinitialize currency conversion when drawer opens
        if (typeof initialCurrencyChange === 'function') {
          initialCurrencyChange();
        }
        
        // Update footer count if function exists
        if (typeof updateFooterCount === 'function') {
          updateFooterCount();
        }
      }, 100);
    }, { once: true });

    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    this.setCountinueShoppingButtonLink();
    // Ensure checkout button is enabled when cart drawer opens
    this.ensureCheckoutButtonEnabled();
    
    // Also trigger currency conversion immediately (in case transitionend doesn't fire)
    setTimeout(() => {
      // Hide any loading spinners
      this.querySelectorAll('.loading__spinner').forEach(spinner => {
        spinner.classList.add('hidden');
      });
      
      // Reinitialize currency conversion when drawer opens
      if (typeof initialCurrencyChange === 'function') {
        initialCurrencyChange();
      }
      
      // Update footer count if function exists
      if (typeof updateFooterCount === 'function') {
        updateFooterCount();
      }
    }, 300);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  /*
    ┌─────────────────────────────────────────────────────────────────────────────┐
    │   Render Content is Called By Product Form on Adding Product to Cart        │
    │   From PDP, Quick View,                                                     │
    └─────────────────────────────────────────────────────────────────────────────┘
  */
  renderContents(parsedState) {
    // Remove 'is-empty' class from drawer__inner if it exists - this indicates the cart is no longer empty
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') {
        // Special handling for cart-icon-bubble
        const sectionHTML = parsedState.sections[section.id];
        if (sectionHTML) {
          const htmlDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');
          // Try to find the section content - it might be wrapped in .shopify-section
          let sectionContent = htmlDoc.querySelector('.shopify-section');
          if (!sectionContent) {
            sectionContent = htmlDoc.querySelector(`#${section.id}`);
          }
          if (!sectionContent) {
            sectionContent = htmlDoc.body.firstElementChild;
          }
          
          if (sectionContent) {
            const targetElement = document.getElementById('cart-icon-bubble');
            if (targetElement) {
              // Update the entire cart-icon-bubble element with the new content
              targetElement.innerHTML = sectionContent.innerHTML;
              
              // Re-attach event listeners if needed
              this.setHeaderCartIconAccessibility();
            }
          }
        }
      } else {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      // Hide all loading spinners first
      this.querySelectorAll('.loading__spinner').forEach(spinner => {
        spinner.classList.add('hidden');
      });
      
      // Reinitialize currency conversion - critical for price conversion
      if (typeof initialCurrencyChange === 'function') {
        initialCurrencyChange();
      }
      
      // Update footer count if function exists
      if (typeof updateFooterCount === 'function') {
        updateFooterCount();
      }
      
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      
      /*
      /*
       ┌─────────────────────────────────────────────────────────────────────────────┐

       │       This will also set the Highest Cutoff Variant on Cart                 │

       └─────────────────────────────────────────────────────────────────────────────┘
     */

      // Reset flags to ensure proper attribute updates
      // window.isCityChangedFired = false;
      // window.isShippingMethodChangeFired = false;
      // window.isRestCartAttributeFired = false;
      // window.isCartAttributeChangeFired = false;

      /*
      // Only reset attributes if they are actually null
      const currentAttributes = parsedState.attributes || {};
      if (currentAttributes.shipping_date && currentAttributes.english_city) {
        // Always refresh shipping methods for restored city and date
        this.cartItems.getLatestShippingMethods({
          city: currentAttributes.english_city,
          date: currentAttributes.shipping_date.split('-').reverse().join('-')
        });
      } else {
        this.cartItems.resetCartAttributes(true);
        this.cartItems.getLatestShippingMethods();
      }
      */

      this.open();
      // Ensure checkout button is enabled after rendering contents
      this.ensureCheckoutButtonEnabled();
      
      // Trigger currency conversion again after drawer opens (extra safety)
      setTimeout(() => {
        // Hide any remaining loading spinners
        this.querySelectorAll('.loading__spinner').forEach(spinner => {
          spinner.classList.add('hidden');
        });
        
        // Reinitialize currency conversion after drawer animation
        if (typeof initialCurrencyChange === 'function') {
          initialCurrencyChange();
        }
      }, 400);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
        section: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /*
  // Add this helper function
  formatTimeToAMPM(timeSlot) {
    if (!timeSlot || timeSlot === 'null') return '';

    try {
      return timeSlot.split(' - ').map(time => {
        const [hours, minutes] = time.split(':');
        if (!hours || !minutes) return '';

        const hour = parseInt(hours);
        if (isNaN(hour)) return '';

        const ampm = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 || 12;
        return `${formattedHour}:${minutes} ${ampm}`;
      }).filter(Boolean).join(' - ');
    } catch (e) {
      return '';
    }
  }
  */

  /*
  async getLatestCartData() {
    try {
      const data = await this.cartItems.getLatestCartData();
      return data;
    } catch (error) {
      console.error(`🚀 || cart-drawer.js:120 || CartDrawer || getLatestCartData || error:`, error);
    }
  }
  */
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
    ];
  }
  
  updateCartIconBubble(sectionHTML) {
    if (!sectionHTML) return;
    
    const htmlDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    // Try to find the section content - it might be wrapped in .shopify-section
    let sectionContent = htmlDoc.querySelector('.shopify-section');
    if (!sectionContent) {
      sectionContent = htmlDoc.querySelector('#cart-icon-bubble');
    }
    if (!sectionContent) {
      sectionContent = htmlDoc.querySelector('#shopify-section-cart-icon-bubble');
    }
    if (!sectionContent) {
      sectionContent = htmlDoc.body.firstElementChild;
    }
    
    if (sectionContent) {
      const targetElement = document.getElementById('cart-icon-bubble');
      if (targetElement) {
        // Update the entire cart-icon-bubble element with the new content
        targetElement.innerHTML = sectionContent.innerHTML;
        
        // Re-attach event listeners
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.setHeaderCartIconAccessibility) {
          cartDrawer.setHeaderCartIconAccessibility();
        }
      }
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
